import {
  AfterViewInit,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TaskDialogeComponent } from '../task-dialoge/task-dialoge.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';

@Component({
  selector: 'app-task-reminder-details',
  templateUrl: './task-reminder-details.component.html',
  styleUrls: ['./task-reminder-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TaskReminderDetailsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  sidebarFolded: boolean;
  @Input() taskData: any;
  displayedColumns: string[] = ['DESCRIPTION', 'STARTDATE'];
  currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
  @Input() folderHideshow = false;

  @Output()
  folderHideshowChange = new EventEmitter<boolean>();
  // @ViewChildren(Directive)
  // private _Directives: QueryList<Directive>;
  selectedColore: string = 'var(--highlighted-bg-row)';
  highlightedRows: any;
  ActiveRow: any;
  SnoozeTime: any;
  SnoozeSpiner: boolean = false;
  dissSpiner: boolean = false;
  dissallSpiner: boolean = false;
  @Output() isTaskData: EventEmitter<any> = new EventEmitter<any>();
  @Output() refreshReminders = new EventEmitter<string | undefined>();
  @Output() snoozeComplete = new EventEmitter<{
    taskGuid: string;
    reopenAfterMs: number;
    reminderMinutes: number;
  }>();
  // Private
  // private _chatViewScrollbar: Directive;
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {ChatPanelService} _chatPanelService
   * @param {HttpClient} _httpClient
   * @param {FuseSidebarService} _fuseSidebarService
   */
  constructor(
    private _httpClient: HttpClient,
    // private _fuseSidebarService: FuseSidebarService,
    public dialog: MatDialog,
    public behaviorService: BehaviorService,
    private toastr: ToastrService,
    private _mainAPiServiceService: MainAPiServiceService,
  ) {
    // Set the defaults
    this.sidebarFolded = true;

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }
  /**
   * On init
   */
  ngOnInit(): void {
    this.syncActiveRow();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['taskData']) {
      this.syncActiveRow();
    }
  }

  private syncActiveRow(): void {
    const list = this.taskData || [];
    const stillThere = list.find((t) => t.TASKGUID === this.highlightedRows);
    if (stillThere) {
      this.ActiveRow = stillThere;
      return;
    }
    if (list[0]) {
      this.ActiveRow = list[0];
      this.highlightedRows = list[0].TASKGUID;
      this.behaviorService.TaskData(list[0]);
      return;
    }
    this.ActiveRow = '';
    this.highlightedRows = '';
    this.behaviorService.TaskData(null);
    this.isTaskData.emit(false);
  }

  /**
   * This function is used to edit the Data
   */
  editData(row: any) {
    this.behaviorService.TaskData(row);
    const dialogRef = this.dialog.open(TaskDialogeComponent, {
      disableClose: true,
      panelClass: 'dialog-panel-class',
      backdropClass: 'cdk-overlay-dark-backdrop',
      data: { action: 'edit' },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.refreshReminders.emit();
      }
    });
  }

  /**
   * This function is used to dismiss all data
   */
  dissmissAll() {
    this.dissallSpiner = true;
    this.taskData.forEach((element) => {
      let postData = {
        FormAction: 'Dismiss',
        DATA: { TASKGUID: element.TASKGUID },
      };
      this._mainAPiServiceService
        .getSetData(postData, 'task')
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(
          (res) => {
            this.dissallSpiner = false;
            if (res.STATUS == 'success' && res.CODE == 200) {
              this.refreshReminders.emit();
            }
          },
          (error) => {
            this.dissallSpiner = false;
            this.toastr.error(error);
          },
        );
    });
  }

  /**
   * Handles the change event for the snooze time selection.
   *
   * @param value - The selected snooze time value.
   * @returns void
   */
  onSnoozeTimeChange(value: string): void {
    this.SnoozeTime = value;
  }

  /**
   * This function is used to Snooj the data
   */
  Snooze(row: any) {
    if (!row?.TASKGUID) {
      return;
    }
    if (this.SnoozeTime) {
      this.SnoozeSpiner = true;
      this.foldSidebarTemporarily();
      let T = this.SnoozeTime.split(':');
      let data: any = {};
      data['TASKGUID'] = row.TASKGUID;
      data[T[0]] = Number(T[1]);
      let postData = { FormAction: 'Snooze', DATA: data };
      this._mainAPiServiceService
        .getSetData(postData, 'task')
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(
          (res) => {
            this.SnoozeSpiner = false;
            if (res.STATUS == 'success' && res.CODE == 200) {
              const amount = Number(T[1]);
              const reminderMinutes = T[0] === 'DAYS' ? amount * 1440 : amount;
              const reopenAfterMs = reminderMinutes * 60000;
              this.snoozeComplete.emit({
                taskGuid: row.TASKGUID,
                reopenAfterMs,
                reminderMinutes,
              });
            } else {
              this.unfoldSidebarTemporarily();
            }
          },
          (error) => {
            this.SnoozeSpiner = false;
            this.unfoldSidebarTemporarily();
            this.toastr.error(error);
          },
        );
    } else {
      this.toastr.warning('Can you please select snooze time');
    }
  }

  /**
   * This function is used to dismiss the data
   */
  dissmiss(row) {
    if (!row?.TASKGUID) {
      return;
    }
    this.dissSpiner = true;
    let postData = {
      FormAction: 'Dismiss',
      DATA: { TASKGUID: row.TASKGUID },
    };
    this._mainAPiServiceService
      .getSetData(postData, 'task')
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(
        (res) => {
          this.dissSpiner = false;
          if (res.STATUS == 'success' && res.CODE == 200) {
            this.refreshReminders.emit(row.TASKGUID);
          }
        },
        (error) => {
          this.dissSpiner = false;
          this.toastr.error(error);
        },
      );
  }

  /**
   * It runs only once after the component's view has been rendered.
   */
  ngAfterViewInit(): void {}

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  /**
   * Fold the temporarily unfolded sidebar back
   */
  foldSidebarTemporarily() {
    this.folderHideshowChange.emit(false);
  }

  /**
   * Unfold the sidebar temporarily
   */
  unfoldSidebarTemporarily() {
    this.folderHideshowChange.emit(true);
  }

  /**
   * Toggle sidebar opened status
   */
  toggleSidebarOpen(): void {
    // this._fuseSidebarService.getSidebar('chatPanel').toggleOpen();
  }
}
